import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

import {
  locationAddressChanged,
  locationLongitudeChanged,
  locationLatitudeChanged,
} from './actions';
import { mapboxKey } from '../../../../config/settings';

class Geocoder extends React.Component {
  componentDidMount() {
    const { map } = this.context; // map is from 'mapbox-gl'
    const { center } = this.props;
    map.addSource('single-point', {
      type: 'geojson',
      data: { type: 'FeatureCollection', features: [] },
    });
    map.addLayer({
      id: 'point',
      source: 'single-point',
      type: 'circle',
      paint: { 'circle-radius': 10, 'circle-color': '#007cbf' },
    });

    if (!isEmpty(center)) {
      map.getSource('single-point').setData({
        type: 'Point',
        coordinates: center,
      });
    }

    const geocoder = new MapboxGeocoder({ accessToken: mapboxKey });
    geocoder.on('result', ({ result }) => {
      map.getSource('single-point').setData(result.geometry);
      this.props.locationAddressChanged(result.place_name);
      this.props.locationLongitudeChanged(result.center[0]);
      this.props.locationLatitudeChanged(result.center[1]);
    });
    map.addControl(geocoder);
  }

  render() {
    return null;
  }
}

Geocoder.contextTypes = {
  map: PropTypes.object.isRequired,
};

Geocoder.propTypes = {
  locationAddressChanged: PropTypes.func.isRequired,
  locationLongitudeChanged: PropTypes.func.isRequired,
  locationLatitudeChanged: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  locationAddressChanged,
  locationLongitudeChanged,
  locationLatitudeChanged,
};

export default connect(mapStateToProps, mapDispatchToProps)(Geocoder);



// WEBPACK FOOTER //
// ./src/modules/locations/cards/AddLocationCard/Geocoder.js